<template>
  <roe-error-message :field="design.match_contrib_based_yos_yesno">
    <roe-radio-input
      v-model="design.$model.match_contrib_based_yos_yesno"
      :disabled-yes="design.$model.employer_match_yos_vary_ee === 'yes'"
      @change="resetApplicableYear"
    ></roe-radio-input>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import RoeRadioInput from "@/components/_shared/inputs/RadioInput";
import {EmployerMatchMixin} from "@/components/_shared/inputs/design/_mixins";
export default {
  name: "RoeEmployerMatchContribBasedYosRadio",
  components: { RoeRadioInput, RoeErrorMessage },
  mixins: [EmployerMatchMixin],
  props: {
    design: Object
  },
  methods: {
    resetApplicableYear() {
      if (this.design.$model.match_contrib_based_yos_yesno === 0)
        this.design.$model.tiers.forEach(tier => (tier.applicable_year = null));
    }
  }
};
</script>
